/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  OnChainPixelArtv2,
  OnChainPixelArtv2Interface,
} from "../OnChainPixelArtv2";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "base64Encode",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "layer1",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "layer2",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "totalPixels",
        type: "uint256",
      },
    ],
    name: "composeLayers",
    outputs: [
      {
        internalType: "uint256[]",
        name: "comp",
        type: "uint256[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "palette1",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "palette2",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "colorCount1",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "colorCount2",
        type: "uint256",
      },
    ],
    name: "composePalettes",
    outputs: [
      {
        internalType: "uint256[]",
        name: "composedPalette",
        type: "uint256[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "colors",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "pixelCompression",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "colorCount",
        type: "uint256",
      },
    ],
    name: "encodeColorArray",
    outputs: [
      {
        internalType: "uint256[]",
        name: "encoded",
        type: "uint256[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "layers",
        type: "uint256[]",
      },
    ],
    name: "getColorCount",
    outputs: [
      {
        internalType: "uint256",
        name: "colorCount",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "canvas",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "palette",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "xDim",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "yDim",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "svgExtension",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "paddingX",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "paddingY",
        type: "uint256",
      },
    ],
    name: "render",
    outputs: [
      {
        internalType: "string",
        name: "svg",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "toHexString",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "toString",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "data",
        type: "string",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "encoded",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "data",
        type: "string",
      },
    ],
    name: "uriSvg",
    outputs: [
      {
        internalType: "string",
        name: "encoded",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b50610ce4806100206000396000f3fe608060405234801561001057600080fd5b506004361061009d5760003560e01c80636900a3ae116100665780636900a3ae146101245780638fba8d5c14610137578063c19728641461014a578063d5fb1b191461016b578063e89cec8f1461017e57600080fd5b80624aaa15146100a25780630de72b7e146100cb5780635b2125fa146100eb5780635bab8bda146100fe5780635ef8c13414610111575b600080fd5b6100b56100b0366004610746565b610191565b6040516100c29190610aa4565b60405180910390f35b6100de6100d936600461095e565b610229565b6040516100c29190610bd8565b6100b56100f93660046107b0565b6102bd565b6100b561010c3660046108cc565b61035a565b6100de61011f366004610821565b610398565b6100de6101323660046109fb565b61043e565b6100de6101453660046109fb565b610479565b61015d610158366004610680565b6104b4565b6040519081526020016100c2565b6100de610179366004610918565b61053e565b6100de61018c36600461095e565b610578565b604051624aaa1560e01b815260609073__$2e286f769ee588d09b231b39a8f53392dc$__90624aaa15906101cd90879087908790600401610ae8565b60006040518083038186803b1580156101e557600080fd5b505af41580156101f9573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261022191908101906106b3565b949350505050565b6040516306f395bf60e11b815260609073__$2e286f769ee588d09b231b39a8f53392dc$__90630de72b7e90610263908590600401610bd8565b60006040518083038186803b15801561027b57600080fd5b505af415801561028f573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526102b79190810190610991565b92915050565b604051632d9092fd60e11b815260609073__$2e286f769ee588d09b231b39a8f53392dc$__90635b2125fa906102fd908890889088908890600401610b1e565b60006040518083038186803b15801561031557600080fd5b505af4158015610329573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261035191908101906106b3565b95945050505050565b604051632dd5c5ed60e11b815260609073__$2e286f769ee588d09b231b39a8f53392dc$__90635bab8bda906101cd90879087908790600401610bb3565b6040516317be304d60e21b815260609073__$6911898b6c9b16b74576d7d8f2c63f8b8f$__90635ef8c134906103de908b908b908b908b908b908b908b90600401610b57565b60006040518083038186803b1580156103f657600080fd5b505af415801561040a573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526104329190810190610991565b98975050505050505050565b60405163348051d760e11b81526004810182905260609073__$2e286f769ee588d09b231b39a8f53392dc$__90636900a3ae90602401610263565b6040516323eea35760e21b81526004810182905260609073__$2e286f769ee588d09b231b39a8f53392dc$__90638fba8d5c90602401610263565b604051633065ca1960e21b815260009073__$2e286f769ee588d09b231b39a8f53392dc$__9063c1972864906104ee908590600401610a91565b60206040518083038186803b15801561050657600080fd5b505af415801561051a573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906102b79190610a13565b60405163d5fb1b1960e01b815260609073__$2e286f769ee588d09b231b39a8f53392dc$__9063d5fb1b1990610263908590600401610bd8565b60405163e89cec8f60e01b815260609073__$2e286f769ee588d09b231b39a8f53392dc$__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";

type OnChainPixelArtv2ConstructorParams =
  | [linkLibraryAddresses: OnChainPixelArtv2LibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: OnChainPixelArtv2ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class OnChainPixelArtv2__factory extends ContractFactory {
  constructor(...args: OnChainPixelArtv2ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(
        _abi,
        OnChainPixelArtv2__factory.linkBytecode(linkLibraryAddresses),
        signer
      );
    }
  }

  static linkBytecode(
    linkLibraryAddresses: OnChainPixelArtv2LibraryAddresses
  ): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$2e286f769ee588d09b231b39a8f53392dc\\$__", "g"),
      linkLibraryAddresses[
        "contracts/OnChainPixelArtLibrary.sol:OnChainPixelArtLibrary"
      ]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$6911898b6c9b16b74576d7d8f2c63f8b8f\\$__", "g"),
      linkLibraryAddresses[
        "contracts/OnChainPixelArtLibraryv2.sol:OnChainPixelArtLibraryv2"
      ]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<OnChainPixelArtv2> {
    return super.deploy(overrides || {}) as Promise<OnChainPixelArtv2>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): OnChainPixelArtv2 {
    return super.attach(address) as OnChainPixelArtv2;
  }
  connect(signer: Signer): OnChainPixelArtv2__factory {
    return super.connect(signer) as OnChainPixelArtv2__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): OnChainPixelArtv2Interface {
    return new utils.Interface(_abi) as OnChainPixelArtv2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OnChainPixelArtv2 {
    return new Contract(address, _abi, signerOrProvider) as OnChainPixelArtv2;
  }
}

export interface OnChainPixelArtv2LibraryAddresses {
  ["contracts/OnChainPixelArtLibrary.sol:OnChainPixelArtLibrary"]: string;
  ["contracts/OnChainPixelArtLibraryv2.sol:OnChainPixelArtLibraryv2"]: string;
}
